import React from 'react'
import PropTypes from 'prop-types'

import Page from '../container/Page'

import componentRenderer from '../componentRenderer'
import usePreviewData from '../../hooks/usePreviewData'
import useParseSiteData from '../../hooks/useParseSiteData'

const ListingPage = ({
  location,
  pageContext: { staticData },
  skipPreview,
}) => {
  const data = usePreviewData(staticData)
  const { components, sections, social } = useParseSiteData(data)

  return (
    <Page noPaddingTop {...sections}>
      {!!components && componentRenderer(components, { social })}
    </Page>
  )
}

ListingPage.propTypes = {
  location: PropTypes.object,
  pageContext: PropTypes.object,
  skipPreview: PropTypes.bool,
}

export default ListingPage
